import financial from "../assets/images/financial.png";
import hospitality from "../assets/images/hospitality.png";
import estate from "../assets/images/estate.png";
import agroAllied from "../assets/images/agroAllied.png";
import renewable from "../assets/images/renewable.png";
import technology from "../assets/images/technology.png";
import healthcare from "../assets/images/healthcare.png";

export const portfolioData = [
  {
    img: financial,
    heading: "Financial Services",
    text: [
      "At PAC Holdings, Financial Services is our strength and flagship space. Through the years, we have penetrated the financial services value-chain and have positioned ourselves to deliver value through investment banking and advisory, asset management, securities trading, registrar services, trusteeship and supply-chain finance. We have only one goal – leverage opportunities and unlock wealth.",
    ],
    link: "/portfolio/financial-services",
    page: true,
    headingColor: "#38B6FF",
  },

  {
    img: hospitality,
    heading: "Hospitality & Entertainment",
    text: [
      "The Amber Hospitality Services Limited is a hospitality management and development company, created by hoteliers and financial professional aiming to bring into the industry a comprehensive understanding of management and development, by implementing the right approaches that this industry requires.",
      "Our roots are in Africa, but our business knowledge was gathered around the world and in all kinds of hospitality operations, despite all the challenges that the industry faces nowadays our mission is still to provide responsible management solutions.",
      "Amber Hospitality Services Limited has developed different Brands to reach all angles of the industry, targeting customer satisfaction by delivering exceptional services and quality products. By meeting and continually endeavouring to exceed our customers' expectations, we will produce the results needed to satisfy and attract investors and continue our individual and corporate growth.",
    ],
    link: "/portfolio/hospitality",
    page: true,
    headingColor: "#FAB400",
  },
  {
    img: estate,
    heading: "Real Estate & Infrastructure",
    text: [
      "BRICS Property And Infrastructure Development Limited is the Group’s real estate and infrastructure development arm.",
      "We seek value-added opportunities across Residential Real Estate Development, Commercial Real Estate Development and Infrastructure/PPP Development with Government.",
      "Properties currently within our real estate portfolio includes residential apartment, office complex, sport facilities and virgin lands, all situated within prime locations. Our core services are Infrastructure Development, Facility Management and Property Management/Marketing.",
      "In conjunction with our real estate strategic partners, we are currently developing a new 200 hectares island from the Lagos lagoon along the Lekki Corridor. This new city is a work, live and play island estimated to house about 10,000 people.",
    ],
    link: "/portfolio/real-estate",
    page: true,
    headingColor: "#4E2E8F",
  },
  {
    img: agroAllied,
    heading: "Agro-allied & FMCG",
    text: [
      "Agriculture is one of the pillars of the Nigerian economy with contribution of an average of 25% to real GDP. PAC Holdings is actively participating in this sector by investing in agro-processing, including processing of Agricultural products with export potential.",
      "Major investments undertaken in this sector include:",
      " AAn industrial mango plantation with a ranch/slaughter business-line in Cote D’Voire.",
      "Manufacture and supply of High Quality Cassava Flour (HQCF)/ Commercial and Mechanized Farming of Cassava Tubers.",
    ],
    link: "/portfolio/agro-allied",
    page: true,
    headingColor: "#9ACB34",
  },
  {
    img: renewable,
    heading: "Renewable Energy",
    text: [
      "Tergo Energy is a subsidiary of PanAfrican Capital Holdings Limited that is committed to the utilization of natural gas and renewable energy.",
      "A member of Nigerian Gas Association, we are determined in addressing Africa’s energy challenge through the provision of clean and sustainable energy solutions.",
      "We apply our multi-disciplined technical expertise to the development of natural gas and solar to generate positive results in a responsible manner.",
      "Tergo Energy is committed and dedicated to serving the interests of all our stakeholders by being both a good steward of the resources we operate and delivering attractive returns to our investors.",
    ],
    link: "/portfolio/renewable",
    page: true,
    headingColor: "#105215",
  },
  {
    img: technology,
    heading: "Technology and Media",
    text: [
      "Our investment in the Technology and Media sector encompasses a wide range of technologies and services related to information processing and computer systems. It includes hardware, software, networking, telecommunications equipment, internet services, software development, and IT infrastructure management.",

      "We also have a vested interest in the production, distribution, and consumption of media content. It includes traditional forms of media such as television, radio, newspapers, magazines, and books, as well as newer digital media platforms like online news portals, social media, streaming services, podcasts, and gaming. Our aim is to contribute to the broader media landscape across Africa.",
    ],
    link: "/portfolio/technology",
    page: true,
    headingColor: "#FA6900",
  },
  {
    img: healthcare,
    heading: "Healthcare",
    text: [
      "We operate in the Healthcare sector with the sole objective of making investments in novel and disruptive healthcare platforms, projects, and businesses across the healthcare value chain.",
      "We seek to create value leveraging innovations and strategic partnerships in targeted segments: PPP, Diagnostics, Pharmaceuticals, Digital Health, HMO, Supply Chain, Specialist Services etc.",
    ],
    link: "/portfolio/healthcare",
    page: true,
    headingColor: "#FF0000",
  },
];
